import { type FC, type ReactNode } from "react";
import { Paper, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export interface MetricCardProps {
	readonly label: ReactNode;
	readonly value: ReactNode;
	readonly minWidth?: number;
	readonly variant?: "info" | "metric";
	readonly valueVariant?: "subtitle1" | "h6";
	readonly "data-testid"?: string;
}

export const MetricCard: FC<MetricCardProps> = ({
	label,
	value,
	minWidth = 220,
	variant = "info",
	valueVariant,
	"data-testid": dataTestId,
}) => {
	const isMetric = variant === "metric";
	const defaultValueVariant = isMetric ? "h6" : "subtitle1";

	return (
		<Paper
			sx={{
				p: 2,
				minWidth,
				display: "flex",
				flex: 1,
				flexDirection: "column",
				alignItems: "center",
				gap: 0.5,
				bgcolor: isMetric ? (theme) => alpha(theme.palette.primary.main, 0.06) : "grey.50",
				borderColor: isMetric ? (theme) => alpha(theme.palette.primary.main, 0.2) : "divider",
			}}
			data-testid={dataTestId}
		>
			<Typography variant="overline" color="text.secondary">
				{label}
			</Typography>
			<Typography variant={valueVariant ?? defaultValueVariant} color={isMetric ? "primary.main" : "text.primary"}>
				{value}
			</Typography>
		</Paper>
	);
};
